import { render, staticRenderFns } from "./ImportsList.vue?vue&type=template&id=b464241e&scoped=true"
import script from "./ImportsList.vue?vue&type=script&lang=js"
export * from "./ImportsList.vue?vue&type=script&lang=js"
import style0 from "./ImportsList.vue?vue&type=style&index=0&id=b464241e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b464241e",
  null
  
)

export default component.exports